var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.group)?_c('b-overlay',{staticClass:"pt-2 h-100",attrs:{"show":_vm.wait}},[_c('setups',{ref:"setups",attrs:{"group_id":_vm.group_id,"group":_vm.group},on:{"need_refresh":_vm.refresh}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }